import React from 'react';
import { TrendingUp, Calendar, Target, BarChart } from 'lucide-react';
import './shared-analytics.css';

const ComplianceAnalytics = () => {
  return (
    <div className="compliance-analytics">
      <div className="analytics-summary">
        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#f0fdf4', color: '#16a34a' }}>
            <TrendingUp size={24} />
          </div>
          <div className="card-content">
            <h3>This Week</h3>
            <div className="card-value">68.3%</div>
            <div className="card-change positive">+5.2% from last week</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#eff6ff', color: '#3b82f6' }}>
            <Calendar size={24} />
          </div>
          <div className="card-content">
            <h3>This Month</h3>
            <div className="card-value">65.7%</div>
            <div className="card-change positive">+2.8% from last month</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#faf5ff', color: '#7c3aed' }}>
            <Target size={24} />
          </div>
          <div className="card-content">
            <h3>To Goal</h3>
            <div className="card-value">9.3%</div>
            <div className="card-change neutral">Target: 75%</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#fff7ed', color: '#ea580c' }}>
            <BarChart size={24} />
          </div>
          <div className="card-content">
            <h3>Trend</h3>
            <div className="card-value">↑</div>
            <div className="card-change positive">Improving</div>
          </div>
        </div>
      </div>

      <div className="content-placeholder">
        <h3>Weekly & Monthly Compliance Trends</h3>
        <p>Comprehensive compliance tracking and pattern analysis.</p>
        <ul>
          <li>Week-over-week compliance comparison</li>
          <li>Monthly adherence trends</li>
          <li>Goal tracking and progress</li>
          <li>Compliance rate predictions</li>
          <li>Patient compliance segmentation</li>
        </ul>
      </div>
    </div>
  );
};

export default ComplianceAnalytics;



